import { useMixpanel } from 'gatsby-plugin-mixpanel'
import React, { useState, FC } from 'react'

import { Button } from 'components/buttons'
import SignUpForm from 'components/forms/SignUpForm'
import { Modal } from 'components/layout'
import { createEvent } from 'helpers/gtag'

interface Props {
  primary?: boolean
  label?: string
  formId?: string
  eventLabel: string
  conversionValue: number
  conversionTrackingId: string
}

const BookDemoButton: FC<Props> = ({ label = 'Book a Quick Demo', ...props }) => {
  const mixpanel = useMixpanel()
  const [modalVisibility, setModalVisibility] = useState<boolean>(false)
  const [completedForm, setCompletedForm] = useState<string | null>(null)

  const handleClose = () => {
    setModalVisibility(false)
    setCompletedForm(null)
  }

  return (
    <>
      <Button
        primary={props.primary}
        onClick={() => {
          mixpanel.track(`Opened Book A Demo Modal`)
          setModalVisibility(true)
          createEvent({
            action: 'view_item',
            currency: 'USD',
            value: props.conversionValue,
            items: [
              {
                item_name: props.eventLabel,
              },
            ],
          })
        }}
      >
        {label}
      </Button>

      <Modal
        isVisible={!!modalVisibility}
        setVisibility={handleClose}
        portalId="request-demo-modal"
      >
        {completedForm ? (
          <header>
            <h1>Thank you!</h1>
            <p>We look forward to sharing Happitu with you.</p>
          </header>
        ) : (
          <>
            <header>
              <h1>Book a Demo</h1>
              <p>
                Want to see how Happitu can help your team? Schedule a demo with our
                product experts.
              </p>
            </header>
            <SignUpForm
              formId={props.formId}
              onSubmit={(values: Record<string, string>) => {
                setCompletedForm(values.email)
                mixpanel.track(`Booked Demo`)
                createEvent({
                  action: 'conversion',
                  label: props.eventLabel,
                  sendTo: props.conversionTrackingId,
                  value: props.conversionValue,
                  currency: 'USD',
                })
              }}
              submitLabel="Book Your Free Demo"
            />
          </>
        )}
      </Modal>
    </>
  )
}
export default BookDemoButton
